<template>
    <div class="product-page">
        <div class="matrix-header">
            <h2>芯棚到家智能放风机（旗舰版）</h2>
            <p>温控数据全知晓 智能放风护苗好</p>
        </div>

        <div class="content-wrapper">
            <div class="container">
                <div class="product-card">
                    <el-row :gutter="150" class="product-content">
                        <el-col :span="9" class="product-left" style="padding-right: 0px;padding-left: 100px;">

                            <div class="main-image-container">
                                <img src="@/assets/images/HardwareDetails/juanlianji-qj/ffj.png" :alt="products.title"
                                    class="main-image">
                            </div>
                            <div class="detail-images">
                                <div class="detail-image-item1">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/yddkz.png" alt="控制界面"
                                        class="detail-image">
                                </div>
                                <div class="detail-image-item">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/pcdsjfx.png" alt="机械细节"
                                        class="detail-image">
                                </div>
                                <!-- <div class="detail-image-item">
                                    <img src="@/assets/images/HardwareDetails/juanlianji-qj/yxms.png" alt="控制板"
                                        class="detail-image">
                                </div> -->
                            </div>
                        </el-col>

                        <el-col :span="15" class="product-right">
                            <div class="spec-section1">
                                <h3 class="section-title">主机参数</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.mainSpecs" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>

                            <div class="spec-section">
                                <h3 class="section-title">人机交互</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.electronicLimiter" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="control-mechanism">
                                <h3 class="section-title">自动控制机制</h3>
                                <div class="control-items">
                                    <div class="control-item" v-for="(control, index) in products.autoControls"
                                        :key="index">
                                        <h4 class="control-type">
                                            <img src="@/assets/images/HardwareDetails/juanlianji-qj/shezhi.png"
                                                :alt="`${control.type}图标`" class="control-icon">
                                            {{ control.type }}
                                        </h4>
                                        <p class="control-description">{{ control.description }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="spec-section">
                                <h3 class="section-title">机械限位器</h3>
                                <el-row :gutter="10">
                                    <el-col :span="8" v-for="(spec, index) in products.mechanicalLimiter" :key="index"
                                        class="spec-col">
                                        <div class="spec-item">
                                            <div class="spec-label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>

                            <div class="mode-section">
                                <h3 class="section-title">运行模式</h3>
                                <el-row :gutter="16">
                                    <el-col :span="12" class="mode-col">
                                        <div class="mode-item">
                                            <h4 class="mode-title">自动模式</h4>
                                            <p class="mode-description">{{ products.modes.auto }}</p>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" class="mode-col">
                                        <div class="mode-item">
                                            <h4 class="mode-title">手动模式</h4>
                                            <p class="mode-description">{{ products.modes.manual }}</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div> -->
                        </el-col>
                    </el-row>

                    <div class="data-control-section">
                        <el-row :gutter="24" class="combined-section">
                            <el-col :span="12" class="combined-item">
                                <div class="data-collection">
                                    <h3 class="section-title">智能预警</h3>

                                    <el-row :gutter="12">
                                        <el-col :span="12" v-for="(item, index) in products.warnings" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.type }}</div>
                                                <div class="data-value">{{ item.description }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>

                            <el-col :span="12" class="combined-item">
                                <div class="data-collection">
                                    <h3 class="section-title">数据采集</h3>
                                    <el-row :gutter="12">
                                        <el-col :span="8" v-for="(item, index) in products.dataCollection" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.label }}</div>
                                                <div class="data-value">{{ item.value }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="data-collection">
                                    <h3 class="section-title">智能控制</h3>
                                    <el-row :gutter="12">
                                        <el-col :span="8" v-for="(item, index) in products.contrl" :key="index">
                                            <div class="data-item">
                                                <div class="data-label">{{ item.label }}</div>
                                                <div class="data-value">{{ item.value }}</div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="application-scenarios">
                        <h3 class="section-title">应用场景</h3>
                        <el-row :gutter="16">
                            <el-col :span="6" v-for="(scene, index) in products.scenarios" :key="index">
                                <div class="scene-card">
                                    <div class="scene-image-container">
                                        <img :src="scene.image" :alt="scene.title" class="scene-image">
                                        <div class="scene-title-overlay">
                                            <p class="scene-title">{{ scene.title }}</p>
                                        </div>
                                    </div>
                                    <div class="scene-description">
                                        <p>{{ scene.description }}</p>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <div class="related-products">
                        <h3 class="section-title">相关产品推荐</h3>
                        <el-row :gutter="20">
                            <el-col :span="8" v-for="(product, index) in relatedProducts" :key="index">
                                <div class="related-product-card">
                                    <div class="related-product-image-container">
                                        <img :src="product.image" :alt="product.title" class="related-product-image">
                                    </div>
                                    <div class="related-product-info">
                                        <h4 class="related-product-title">{{ product.title }}</h4>
                                        <p class="related-product-description">{{ product.description }}</p>
                                        <div class="view-details" @click="goToTypicalcase(product.path)">
                                            <span>查看详情</span>
                                            <img src="@/assets/images/HardwareDetails/juanlianji-qj/xiangqing.png"
                                                alt="箭头" class="arrow-icon">
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            products: {
                title: '智能放风机（旗舰版）',
                tags: ['自动模式', '手动模式', '智能预警', '远程控制'],
                scenarios: [
                    {
                        title: '大型温室大棚',
                        description: '为大型温室大棚提供智能化环境控制解决方案，集成物联网技术与智能控制系统，实现温室环境的智能调节与远程监控，提升温室作物的生长效率与品质。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/dp.png')


                    },
                    {
                        title: '智慧农业基地',
                        description: '为现代化农业基地提供一体化智能解决方案，集成物联网技术与智能控制系统，实现农作物生长环境的智能调节与远程监控，大幅提升农业生产效率。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/ny.png')

                    },
                    {
                        title: '花卉培育中心',
                        description: '专门针对花卉培育环境开发的智能控制方案，可根据不同花卉品种的生长需求，精确控制温度、湿度等环境参数，为高品质花卉培育提供最佳生长环境。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/hh.png')

                    },
                    {
                        title: '蔬果种植基地',
                        description: '针对大规模蔬果种植基地设计的智能化环境控制系统，具备分区管理功能，可根据不同作物的生长周期自动调节环境参数，确保产量与品质的最优化。',
                        image: require('@/assets/images/HardwareDetails/juanlianji-qj/sg.png')

                    }
                ],
                mainSpecs: [
                    { label: '尺寸', value: '120×205×42mm' },
                    { label: '主机功率', value: '220V AC' },
                    { label: '负载接入', value: 'DC24V 80~200W 电动卷膜器' },
                ],
                electronicLimiter: [
                    { label: '屏幕', value: '2.4 寸液晶屏' },
                    { label: '按键', value: '菜单、除湿、确认、翻页、开风、关风、手/自动切换' },
                    { label: '防护等级', value: 'IP65' },
                    { label: '安装方式', value: '壁挂安装/悬挂安装 ' },
                    { label: '通信', value: '4G通信 含3年流量' },
                ],
                mechanicalLimiter: [
                    { label: '行程开关类型', value: '不锈钢防水型' },
                    { label: '防护等级', value: 'IP67' },
                    { label: '工作电压', value: '380V' },
                    { label: '线长配置', value: '2米、3米各1个' },
                    { label: '钢丝绳', value: '直径：1mm，长度：4m，配置：1根' },
                    { label: '安装方式', value: '室外安装' }
                ],
                modes: {
                    auto: '只有将设备切换至自动模式时，电子限位、设备控制、设备预警以及自动控制等全部功能方可正常启用，为您带来便捷、智能的操控体验，全方位保障设备运行的安全性与稳定性。',
                    manual: '当设备处于手动模式时，仅机械限位发挥保护作用。在该模式下，您可通过手动操作实现对设备的基本控制，但自动模式下的部分智能化功能将无法使用。'
                },
                dataCollection: [
                    { label: '空气温度' },

                ],
                //智能控制
                contrl: [
                    { label: '自动开关', value: '打开/关闭' },
                    { label: '风口', value: '打开/暂停/关闭' },
                    { label: '一键除湿', value: '打开/关闭' },


                ],
                warnings: [
                    { type: '电力异常预警', description: '系统快速捕捉异常断电、电流过大等电力突变，及时提醒，避免因电力问题影响作物生长。' },
                    { type: '温度异常预警', description: '时刻监测温室温度，当温度过高或过低，马上预警，助您及时调整通风，维持适宜温度。' },
                ],
                autoControls: [
                    {
                        type: '温度报警',
                        description: '设定最高、最低温度阈值，超限时自动报警。'
                    },
                    {
                        type: '电流报警',
                        description: '设定最大工作电流值，超限报警。'
                    },
                    {
                        type: '目标温度',
                        description: '可按不同时间段设置三组目标温度。'
                    },
                    {
                        type: '除湿',
                        description: '设定除湿开度与时长，自动除湿。'
                    }

                ]
            },
            relatedProducts: [
                {
                    title: '智能环境监测站系列',
                    description: '数据实时在手 预警分秒必达',
                    image: require('@/assets/images/MainHardware/hjjcz.png'),
                    path: '/HuanjingjianceDetails'
                },
                {
                    title: '智能水肥一体机系列',
                    description: '省水省肥又省力 增产增收不是梦',
                    image: require('@/assets/images/MainHardware/sfytj.png'),
                    path: '/ShuifeijiDetails'

                },
                {
                    title: '多参数温室环境传感器系列',
                    description: '多参数精准感知  重塑环境监测新高度',
                    image: require('@/assets/images/MainHardware/wscgq.png'),
                    path: '/CanshuDetails'

                }
            ]
        };
    },
    methods: {
        goToTypicalcase(path) {
            if (!path) {
                console.error('Invalid route path');
                return;
            }
            this.$router.push(path).then(() => {
                // 滚动到顶部逻辑
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }
};
</script>
